import { render } from "./ThreeWaysSection.vue?vue&type=template&id=5d90e291&scoped=true"
import script from "./ThreeWaysSection.vue?vue&type=script&lang=js"
export * from "./ThreeWaysSection.vue?vue&type=script&lang=js"

import "./ThreeWaysSection.vue?vue&type=style&index=0&id=5d90e291&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d90e291"]])

export default __exports__